import React from 'react'
import { Youtube, Vimeo } from 'reactjs-social-embed'
import Facebook from './EmbedComponents/Facebook'
import { TikTok } from 'react-tiktok'
import Instagram from './EmbedComponents/Instagram'
import Twitter from './EmbedComponents/Twitter'
var VIMEO_MATCH_RE = /^(?:\/video|\/channels\/[\w-]+|\/groups\/[\w-]+\/videos)?\/(\d+)/

export const Embeds = (props) => {
  const { url, width, height } = props;
  let parsedURL = new URL(url)
  let result;
  if (parsedURL.hostname) {
    result = findEmbedType(parsedURL);
  }
  if (result) {
    switch (result.embed) {
      case 'facebook':
        return <Facebook kind={result.kind} type={result.type} show_text={true} url={result.url} width={width} height={height} />
      case 'instagram':
        return <Instagram url={result.url} width={width} />
      case 'twitter':
        return width ? <Twitter id={result.id} width={width} /> : <Twitter id={result.id} />
      case 'youtube':
        return width ? <Youtube id={result.id} width={width} /> : <Youtube parentClass="p-container" iframeClass="v-container" id={result.id} />
      case 'tiktok':
        return <TikTok url={result.url} />
      case 'vimeo': {
        // Unlisted videos: render the full player URL directly so the privacy hash is kept
        // (reactjs-social-embed rebuilds from the id only and drops it). Public videos keep
        // the existing component path unchanged.
        if (result.hash && result.id) {
          return (
            <iframe
              src={`https://player.vimeo.com/video/${result.id}?h=${result.hash}`}
              width={width ? width : '640'}
              height={height ? `${height}px` : '360'}
              style={{ border: 'none' }}
              frameBorder="0"
              allow="autoplay; fullscreen; picture-in-picture"
              allowFullScreen
            ></iframe>
          )
        }
        return width ? <Vimeo id={result.id} width={width} height={`${height}px`} /> : <Vimeo id={result.id} />
      }
      default:
        return null;
    }
  }
  return null;
}

export const findEmbedType = (url: URL) => {
  if (url.hostname?.indexOf('facebook.com') > -1 || url.hostname?.indexOf('fb.watch') > -1) {
    // Treat watch/video/reel URLs as video, everything else as a post.
    const isFacebookVideo = (value: string) => /\b(videos?|watch|reel)\b/i.test(value || '')
    // Facebook's own embed iframe (plugins/post.php or plugins/video.php) — render it
    // directly as an iframe instead of reconstructing it through the FB JS SDK.
    if (url.pathname.indexOf('/plugins/') > -1) {
      return {
        embed: 'facebook',
        kind: 'iframe',
        type: url.pathname.indexOf('video.php') > -1 ? 'video' : 'post',
        url: url.href
      }
    }
    if (url.searchParams.has('href')) {
      const href = url.searchParams.get('href')
      return {
        embed: 'facebook',
        type: isFacebookVideo(href) ? 'video' : 'post',
        url: href
      }
    }
    // Fall back to the full URL for any other Facebook shape
    // (reel, watch, story.php, permalink.php, photos, share, groups, fb.watch, …)
    // so unmatched URLs never drop through to an undefined return.
    return {
      embed: 'facebook',
      type: url.hostname.indexOf('fb.watch') > -1 || isFacebookVideo(url.pathname) || url.searchParams.has('v') ? 'video' : 'post',
      url: url.href
    }
  }
  else if (url.hostname?.indexOf('youtube.com') > -1) {
    if (url.pathname.indexOf('/watch') > -1) {
      return {
        embed: 'youtube',
        id: url.searchParams.get('v')
      }
    }
    return {
      embed: 'youtube',
      id: url.pathname.split('/')[2]
    }
  }
  else if (url.hostname?.indexOf('youtu.be') > -1) {
    return {
      embed: 'youtube',
      id: url.pathname.split('/')[1]
    }
  }
  else if (url.hostname?.indexOf('vimeo.com') > -1) {
    var match;
    const id = (match = VIMEO_MATCH_RE.exec(url.pathname)) ? match[1] : null
    // Unlisted Vimeo videos need a privacy hash to embed. It appears either as the `h`
    // query param (player.vimeo.com/video/<id>?h=…) or as the path segment after the id
    // (vimeo.com/<id>/<hash>). Capture it so the full player URL can be rendered — the
    // reactjs-social-embed component takes only the id and would drop the hash.
    let hash = url.searchParams.get('h')
    if (!hash && id) {
      const segments = url.pathname.split('/').filter(Boolean)
      const idIndex = segments.indexOf(id)
      if (idIndex > -1 && segments[idIndex + 1]) hash = segments[idIndex + 1]
    }
    return {
      embed: 'vimeo',
      id,
      hash: hash || undefined
    }
  }
  else if (url.hostname?.indexOf('instagram.com') > -1) {
    return {
      embed: 'instagram',
      url: url
    }
  }
  else if (url.hostname?.indexOf('twitter.com') > -1 || url.hostname?.indexOf('x.com') > -1) {
    return {
      embed: 'twitter',
      id: url.searchParams.has('id') ? url.searchParams.get('id') : url.pathname.split('/')[3]
    }
  }
  else if (url.hostname?.indexOf('tiktok.com') > -1) {
    return {
      embed: 'tiktok',
      url: url.href
    }
  }
  else {
    return null;
  }
}






